<script setup lang="ts">
import { useAuthStore } from "@/stores";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const { t } = useI18n();

const route = useRoute();
const authStore = useAuthStore();

const hideAll = computed(() => {
  return (route?.name as string)?.startsWith("formdata_source_");
});

function isContactSubdomain() {
  return typeof window !== 'undefined' && 
         (window.location.hostname === 'cadastro.selfiecheckin.com.br' || 
          window.location.hostname === 'cadastro.selfiecheckin.com' || 
          window.location.hostname === 'cadastro.localhost');
}

const hidePurchaseAdvise = computed(() => {
  const hiddenRoutes = ["/login", "/register", "/recover"];
  return !!authStore.user || hiddenRoutes.includes(route.path) || (route?.name as string)?.startsWith("separate_page") || isContactSubdomain();
});
</script>

<template>
  <section class="footer" v-if="!hideAll">
    <div class="footer-top" v-if="!hidePurchaseAdvise">
      <v-container>
        <h2>{{ t("footerComponent.title") }}</h2>
        <a href="/register">{{ t("footerComponent.freeTrialLink") }}</a>
      </v-container>
    </div>
    <div class="footer-nav" v-if="!(route?.name as string)?.startsWith('formdata_source_')">
      <v-container class="custom-container">
        <div class="top">
          <div>
            <img src="/img/icons/logowhite.png" alt="Seu Logo" class="footer-logo">
            <p>228, Rua Tupi, Santa Cecília
              São Paulo - SP</p>
            <p>CEP - 01233-000</p>
            <p>CNPJ - 56.107.848/0001-79</p>
            <div class="icons">
              <v-icon>mdi-youtube</v-icon>
              <v-icon>mdi-facebook</v-icon>
              <v-icon>mdi-whatsapp</v-icon>
            </div>
          </div>
          <div class="contact">
            <h3>Contato</h3>
            <div class="list">
              <a href="https://wa.me/+5511999396061"><v-icon>mdi-phone-outline</v-icon>+55 11 99939-6061</a>
              <a href="mailto:contato@selfiecheckin.com.br"><v-icon>mdi-email-outline</v-icon>
                contato@selfiecheckin.com.br</a>
            </div>

          </div>
        </div>
        <v-divider></v-divider>
        <div class="footer-copyright">
          <p>Copyright © Selfie Check-In - {{ t("footerComponent.allRights") }}</p>
          <p class="d-flex align-center justify-end" style="gap: .5rem;">Developed by <a href="https://hoomweb.com/"
              target="_blank" class="d-flex"><img src="/img/icons/hoomweb.png" alt=""></a></p>
        </div>
      </v-container>
    </div>
  </section>
</template>

<style scoped>
.footer .footer-top {
  width: 100%;
  background-color: #35AEFA;
  padding-block: 2rem;
}

.footer .footer-top .v-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer .footer-top h2 {
  color: #FFF;
  font-size: 2.3rem;
  width: 50%;
  font-family: 'Inter', sans-serif;
}

.footer .footer-top a {
  color: #FFF;
  font-size: 1.5rem;
  background-color: #8AC834;
  text-decoration: none;
  padding: .5rem 1rem;
  border-radius: .8rem;
  font-weight: 500;
}

.footer-nav {
  background-color: #21597B;
  padding-block: 1rem;
  color: #FFF;
}

.footer-nav .v-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-nav .top {
  display: flex;
  justify-content: space-between;

}

.footer-nav .top p {
  font-weight: 300;
  font-style: italic;
  width: 60%;
}

.footer-nav .top .icons {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.footer-logo {
  width: 10rem;
  padding-top: 1rem;
}

.footer h3 {
  margin-bottom: 1rem;
  font-weight: bold;
  color: #FFF;
  font-size: 1.5rem;
}

.footer p {
  margin: 0;
  font-size: 1.2rem;
}

.footer .contact .list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer .contact .list a {
  text-decoration: none;
  color: #FFF;

}

.footer-copyright {
  align-items: center;
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

@media (max-width: 768px) {
  .footer .footer-top .v-container {
    flex-direction: column;
    gap: 2rem;
  }

  .footer .footer-top h2 {
    width: 100%;
    text-align: center;
    font-size: 1.8rem;
  }
}
</style>